import cx from 'classnames';
import { useTranslations } from 'next-intl';

import { Pnl } from '@flipster/features/src/shared/pnl';
import { hstack } from '@flipster/styled-system/patterns';
import { Price } from '@flipster/ui';
import { UsdtCurrency } from '@flipster/utils/constants/currency';

import { TpslSchema } from '@web/features/modals/TimeTriggerTpslModal/bunja/validation';
import styles from '@web/features/modals/TimeTriggerTpslModal/tpslModal.module.scss';

interface Props {
  positionType: TpslSchema['positionType'];
  price: string;
  pricePrecision: number;
  unrealizedPnl: string;
  unrealizedPnlPercent: string;
  liquidationPrice?: string;
}

const PriceInfos = ({
  positionType,
  price,
  unrealizedPnl,
  unrealizedPnlPercent,
  liquidationPrice,
  pricePrecision,
}: Props) => {
  const transPosition = useTranslations('Position.r250401');
  const isOpenPosition = positionType === 'open';
  return (
    <div className={styles.priceWrapper}>
      <div className={hstack({ gap: 4, w: '100%' })}>
        <p className={styles.title}>
          {isOpenPosition ? transPosition('Entry_price_colon') : transPosition('Order_price_colon')}
        </p>
        <Price price={price} precision={pricePrecision} toFixed fontType='num2' />
      </div>
      <div className={hstack({ gap: 4, w: '100%' })}>
        <p className={styles.title}>{transPosition('Est_pnl_colon')}</p>
        <div className={hstack({ gap: 4 })}>
          <Pnl number={unrealizedPnl} percent={unrealizedPnlPercent} css={{ textStyle: 'Text/L/Monospace/Regular' }}>
            <Pnl.Number /> <Pnl.Percent />
          </Pnl>
          <span className={cx(styles.precision, styles.num2)}>{UsdtCurrency}</span>
        </div>
      </div>
      <div className={hstack({ gap: 4, w: '100%' })}>
        <p className={styles.title}>
          {isOpenPosition ? transPosition('Liquidation_price_colon') : transPosition('Est_liquidation_price_colon')}
        </p>
        <Price price={liquidationPrice} zeroString='-' precision={pricePrecision} toFixed fontType='num2' />
      </div>
      <p className={styles.warn}>{transPosition('Liquidation_price_hint')}</p>
    </div>
  );
};

export default PriceInfos;
